<template>
    <v-row :class="rowClass">
        <template v-for="(depth, index) in limit">
            <v-col :key="index" :cols="cols || 12" :sm="sm || 12 / limit" :md="md || 12 / limit" :class="colClass">
                <v-select
                    v-bind="{
                        ...$attrs,

                        value: select(depth),
                        items: items(depth),
                        itemText: 'name',
                        itemValue: '_id',
                        itemDisabled,

                        placeholder,
                    }"
                    @input="emit"
                />
            </v-col>
        </template>
    </v-row>
</template>

<script>
export default {
    props: {
        value: { type: [Object, String], default: null }, // category || _category

        _disableds: { type: Array, default: () => [] }, // _categories
        categories: { type: Array, default: () => [] },

        placeholder: { type: String, default: "없음" },
        returnObject: { type: Boolean, default: false },

        sm: { type: [String, Number], default: null },
        md: { type: [String, Number], default: null },
        cols: { type: [String, Number], default: null },

        rowClass: { type: String, default: "pa-0" },
        colClass: { type: String, default: "py-3 py-sm-0" },
    },
    data: () => ({
        category: null,
    }),
    computed: {
        limit() {
            return this.findDepth();
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.category = this.findCategory(this.returnObject ? this.value?._id : this.value);
        },

        emit(_category) {
            // 카테고리 "전체" 선택 시 모두 초기화
            // if (!_category) _category = this.category?._parent || null;

            this.category = this.findCategory(_category);
            this.$emit("input", this.returnObject ? this.category : _category);
        },

        findCategory(_category, categories = null) {
            if (!categories) categories = this.categories;

            for (var category of categories) {
                if (category._id == _category) return category;
                else if (category.children) {
                    var result = this.findCategory(_category, category.children);
                    if (result) return result;
                }
            }

            return null;
        },

        items(depth, categories = this.categories) {
            if (depth == 1) return [{ name: "전체", _id: null }, ...categories];
            if (this.category) {
                for (var category of categories) {
                    if (category._id == this.category._id) {
                        if (depth <= this.category.depth) return categories;
                        else if (this.category.depth + 1 == depth) return category.children;
                    } else if (category.children) {
                        var result = this.items(depth, category.children);
                        if (result.length) return depth <= category.depth ? categories : result;
                    }
                }
            }

            return [];
        },

        select(depth) {
            if (this.category) return [...this.category._parents, this.category._id][depth - 1] || null;
            return null;
        },

        findDepth(categories = null, depth = 1) {
            var maxDepth = depth;
            if (!categories) categories = this.categories;
            for (var category of categories) {
                if (category.children && category.children.length) {
                    var result = this.findDepth(category.children, depth + 1);
                    if (maxDepth < result) maxDepth = result;
                }
            }
            return maxDepth;
        },
        itemDisabled(item) {
            return this._disableds.includes(item?._id || item);
        },
    },
};
</script>
